import Theme from "Resources/Theme.json";

export default (x=1) => `${((x * Theme.App.spacing) / 10)}rem`;
